import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const ShabaCodeModal = () => {
    return (
        <div className="shaba-code-modal-wrapper">
            <div className="modal-box" id="shaba-modal-box">
                <IconName name="expand_close" className="icon position-absolute close-icon close-shaba-modal"/>
                <div className="icon-modal d-flex justify-content-center align-items-center position-relative">
                    <div className="circle-icon"></div>
                    <img src="./assets/vendorImages/credit-cards.png" alt="icon"
                         className="image-icon position-absolute xml-10 xmt-4"/>
                </div>
                <div className="modal-information xmt-10">
                    <div className="row">
                        <div className="col-lg-4 key-name">
                            <span className="text">شماره شبای شما :</span>
                        </div>
                        <div className="col-lg-8 value-name xmt-0 xmt-lg-0">
                            <span className="text">IR1234567891234567891234</span>
                        </div>
                        <div className="col-lg-4 key-name xmt-4 xmt-lg-3">
                            <span className="text">نام صاحب حساب :</span>
                        </div>
                        <div className="col-lg-8 value-name xmt-0 xmt-lg-3">
                            <span className="text">وحید ناموری</span>
                        </div>
                        <div className="col-lg-4 key-name xmt-4 xmt-lg-3">
                            <span className="text">بانک عامل :</span>
                        </div>
                        <div className="col-lg-8 value-name xmt-0 xmt-lg-3">
                            <span className="text">ملت</span>
                        </div>
                    </div>
                </div>
                <div className="modal-buttons d-flex justify-content-between align-items-center xmt-3 xmt-lg-6 flex-column flex-lg-row">
                    <div className="text-buttons"><span className="text">آیا صحت اطلاعات فوق را تایید میکنید؟</span>
                    </div>
                    <div className="buttons d-lg-flex align-items-center flex-column flex-lg-row xmt-3 xmt-lg-0">
                        <div className="ok-button close-shaba-modal">بله تایید میکنم</div>
                        <div className="no-button xmt-2 xmt-lg-0">خیر اصلاح میکنم</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShabaCodeModal;
